import { useState, useEffect } from "react";
//API
import API from "../API";

//helpers
import { isPersistedState } from "../helpers";

//For resetting
// from movie API
const initialState = {
  page: 0,
  results: [],
  total_pages: 0,
  total_results: 0,
};

export const useHomeFetch = () => {
  // Hook (UseState)
  // destructuring
  const [searchTerm, setSearchTerm] = useState("");
  const [state, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  console.log(searchTerm);

  const fetchMovies = async (page, searchTerm = "") => {
    try {
      setError(false);
      setLoading(true);

      const movies = await API.fetchMovies(searchTerm, page);

      // putting movies in the state
      // previous state?!?

      // return an object?
      setState((prev) => ({
        // spread operator creates a new object
        // when setting state in react provide it with a new value
        // never mutate the state directly
        // if you mutate state directly it wont rerender
        // always use setter to modify the state
        // always provide a new value

        ...movies,

        results:
          page > 1 ? [...prev.results, ...movies.results] : [...movies.results], // append new movies
      }));
    } catch (error) {
      setError(true);
    }
    setLoading(false);
  };

  //Inital and search
  useEffect(() => {
    if (!searchTerm) {
      const sessionState = isPersistedState("homeState");

      if (sessionState) {
        console.log("Grabbing from sessionStorage");
        setState(sessionState);
        return;
      }
    }

    console.log("Grabbing from API");
    setState(initialState);
    fetchMovies(1, searchTerm);
  }, [searchTerm]); // runs only once if dependency array is empty

  // Load More
  useEffect(() => {
    if (!isLoadingMore) return;

    fetchMovies(state.page + 1, searchTerm);
    setIsLoadingMore(false);
  }, [isLoadingMore, searchTerm, state.page]);

  //Write to sessionStorage
  useEffect(() => {
    if (!searchTerm) sessionStorage.setItem("homeState", JSON.stringify(state));
  }, [searchTerm, state]);

  return {
    state: state,
    loading,
    error,
    searchTerm,
    setSearchTerm,
    setIsLoadingMore,
  };
};
